export enum Contests {
    "general" = 0,
    "weddings" = 1,
    "team" = 2,
}